import { render, staticRenderFns } from "./facebookImageUpload.vue?vue&type=template&id=6f38bee9&scoped=true&"
import script from "./facebookImageUpload.vue?vue&type=script&lang=js&"
export * from "./facebookImageUpload.vue?vue&type=script&lang=js&"
import style0 from "./facebookImageUpload.vue?vue&type=style&index=0&id=6f38bee9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f38bee9",
  null
  
)

export default component.exports